export const normalizeProductNumber = (number, pads = 4) => {
  if (!number) {
    number = 0;
  }
  return String(number).padStart(pads, '0');
}
